/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/598/interface/api/cat_10487
 */

import { message } from 'ant-design-vue'
import {
  poll_changeSort_post,
  poll_deleteOptionGroup_post,
  poll_listOptionGroup_post,
  poll_optionGroupDetail_post,
  poll_pageList_post,
  poll_save_post,
  poll_saveOptionGroup_post,
  poll_updateOptionGroupStatus_post
} from 'server/modules/10487'

// 选项组重排序
export const poll_changeSort_post_ = async function(params, state) {
  const { success, retInfo } = await poll_changeSort_post(params)
  if (success) {
    state.initList()
    message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 删除投票选项组
export const poll_deleteOptionGroup_post_ = async function(params, state) {
  const { success, retInfo } = await poll_deleteOptionGroup_post({
    pollOptionGroupId: params.id,
    ...state.searchParams
  })
  if (success) {
    state.initList()
    message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询投票选项组列表
export const poll_listOptionGroup_post_ = async function(state) {
  const { searchParams, pagination } = state
  const { success, data, retInfo } = await poll_listOptionGroup_post({
    current: pagination.pageNum,
    size: pagination.pageSize,
    ...searchParams
  })
  if (success) {
    state.dataSource = data
    // state.pagination = {
    //   pageNum: data.current,
    //   pageSize: data.size,
    //   total: data.total
    // }
  } else {
    message.error(retInfo)
  }
}

// 查询投票选项组详情
export const poll_optionGroupDetail_post_ = async function(params) {
  const { success, data, retInfo } = await poll_optionGroupDetail_post(params)
  if (success) {
    return Promise.resolve(data)
  } else {
    message.error(retInfo)
    return Promise.reject(data)
  }
}

// 投票活动分页列表
export const poll_pageList_post_ = async function(state) {
  const { searchParams, pagination } = state
  const { success, data, retInfo } = await poll_pageList_post({
    current: pagination.pageNum,
    size: pagination.pageSize,
    item: { ...searchParams }
  })
  if (success) {
    state.dataSource = data.records
    state.pagination = {
      pageNum: data.current,
      pageSize: data.size,
      total: data.total
    }
  } else {
    message.error(retInfo)
  }
}

// 新增/编辑投票活动
export const poll_save_post_ = async function(state) {
  let params = {
    ...state.searchParams,
    ...state.postParams,
    status: state.postParams.status ? 1 : 0
  }
  if (!params.id) {
    delete params.id
  }

  const { success, retInfo } = await poll_save_post({
    ...params
  })
  if (success) {
    state.initList()
    state.voteVisibleChange(false)
    message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 新增/编辑投票选项组
export const poll_saveOptionGroup_post_ = async function(state) {
  console.log(state)
  let params = {
    ...state.postParams,
    status: state.postParams.status ? 1 : 0
  }
  if (!state.addOrEdit) {
    params.id = state.postParams?.id
  }
  if (!params.pollId) {
    delete params.pollId
  }
  if (!params.id) {
    delete params.id
  }
  const { success, retInfo } = await poll_saveOptionGroup_post(params)
  if (success) {
    state.initList()
    state.voteVisibleChange(false)
    message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 禁用/启用投票选项组
export const poll_updateOptionGroupStatus_post_ = async function(
  params,
  state
) {
  const { success, retInfo } = await poll_updateOptionGroupStatus_post({
    pollOptionGroupId: params.id,
    status: params.status ? 0 : 1
  })
  if (success) {
    state.initList()
    message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}
